import React from 'react'

const SavingAccount = () => {

    const features = [
        {
            title: 'Silent Features',
            points: [
                'Minimum balance Rs. 1000 with effect from 10.07.2022',
                'A person legally empowered to operate a minor’s account can file a nomination on behalf of the minor',
                'Applicants can make a nomination by filling up the prescribed form',
                'The nomination details can be changed during the subsistence of the account relationship by filling up the form prescribed',
                'The account can be opened only for an individual, no joint account facility is available.',
                'Minor cannot open Savings Account',
                'Nomination compulsory, in case the nominee is minor, appointee required with KYC',
                'Up to Rs. 20000 cash will be accepted above that cheque is compulsory',
                'Cash deposit above Rs. 49,999 PAN Card is compulsory.',
                'Duplicate passbook will be charged Rs.200/-',
                'No hidden charges in this scheme.',
                'No transaction charges.',
                'No credit and debit charges.',
                'No service charges in doorstep banking.'
            ]
        },
        {
            title: 'Note',
            points: [
                'Please produce the original documents for verification and a photocopy of each document',
                'Mandatory to provide permanent address and telephone number',
                'Please avail of the nomination facility',
                'Mandatory to complete the KYC Norms',
            ]
        }
    ]
    return (
        <div className='flex-grow pt-16'>
            <div className="text-center mb-16">
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                    Get More From Your Money
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    Access your money anytime and anywhere.
                </p>
            </div>
            <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20'>
                {
                    features.map((feature) => (
                        <div className='mb-8'>
                            <h2 className='text-xl font-bold text-black mb-4'>{feature.title}</h2>
                            {feature.points.map((point, featureIndex) => (
                                <div key={featureIndex} className="flex items-center space-x-2">
                                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                                    <span className="text-sm text-gray-600">{point}</span>
                                </div>
                            ))}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default SavingAccount
